<template>
	<div class="tableWrap">
		<div class="head">
			<span @click="goBack" class="back">
				<i>&nbsp;</i>返回</span>
			<span class="mx">BU职级明细</span>
			<p class="select">
				<el-date-picker class="top-choose" v-model="datePick_start" type="date" placeholder="选择日期" :picker-options="picker_special">
				</el-date-picker>
				<small>~</small>
				<el-date-picker class="top-choose" v-model="datePick_end" type="date" placeholder="选择日期" :picker-options="picker_special">
				</el-date-picker>
				<el-button type="primary" style="margin-left:20px;" @click="search()">查询</el-button>
			</p>
		</div>

		<div class="table-main">
			<div class="main-head">
				<div>日期</div>
				<div>周期</div>
				<div>职级变化</div>
				<div>可分配职级</div>
				<div>详情</div>
			</div>
			<z-scrollDiv class="main-wrap">
				<div class="main-item" v-for="item in dataList" :key="item.id">
					<div>{{ item.bill_time }}</div>
					<div>{{ item | cycleStr }}</div>
					<div>{{ calcStr(item) }}级</div>
					<div>{{ item.balance }}级</div>
					<div class="overhide" :title="item.remark">{{ item.remark }}</div>
				</div>
				<z-noData :list="dataList"></z-noData>
			</z-scrollDiv>
		</div>

		<z-pagination @getPage="search" :data='data'></z-pagination>
	</div>
</template>



<script type="text/ecmascript-6">
	import { mapState } from 'vuex'

	export default {
		data() {
			return {
				datePick_start:"",
				datePick_end:"",

				data:{},  //职级数据
			}
		},
		computed: {
			...mapState(["picker_special"]),
			dataList(){
				return this.data.list;
			},
		},

		created(){
			this.refresh();
		},

		methods: {
			goBack() {  //回退
				this.$router.push({
					name:'info-money',
				});
			},
			refresh(obj={}){  //获取值
				let url = "api/manager/pmt_level_detail";
				this.$http.get(url,{params:obj}).then(res=>{
					if(res.status == 200){
						this.data = res.res_data;
					}
				});
			},
			search(page){  //搜索
				let obj={
					page:page,
					start_date:this.datePick_start,
					end_date:this.datePick_end,
				}
				this.refresh(obj);
			},
			calcStr(item){  //数值拼接
				let operator = item.bill_type == 1?"+":"-";
				let num = item.trans_amount;
				return num == 0?0:operator+num;
			},
		},

	}
</script>


<style lang="less" scoped>
	@import "~src/assets/less/asset-detail.less";
	// **************
	.main-head,.main-item{
		>div{
			&:nth-of-type(1){
				width:15%;
			}
			&:nth-of-type(2){
				width:13%;
				// text-align: center;
			}
			&:nth-of-type(3){
				width:12%;
				// text-align: center;
			}
			&:nth-of-type(4){
				width:12%;
				// text-align: center;
			}
			&:nth-of-type(5){
				max-width:48%;
			}
			

		}
	}
</style>


// WEBPACK FOOTER //
// page-rankTable.vue?18296797